export class FundAllocation {
    constructor(private username: string, private amount: number) { }

    set Username(_username: string) { this.username = _username }
    get Username(): string { return this.username }

    set Amount(_amount: number) { this.amount = _amount }
    get Amount(): number { return this.amount }
}
